var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qaplaContainer"},[_c('a',{staticClass:"btn btn-link",on:{"click":_vm.onStartQaplaSession}},[_vm._v(_vm._s(_vm.$i18n.t("qapla_sso_button")))])])}
var staticRenderFns = []

export { render, staticRenderFns }